import React, {useState} from 'react'

const AdminBlogs = ({ setShowAddBlog }) => {

    const [formData, setFormData] = useState({
            blog_title: '',
            blog_description: '',
            blog_image: null
        })
    
    
        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));
          };
        
          const handleFileChange = (e) => {
            setFormData((prevData) => ({
              ...prevData,
              blog_image: e.target.files[0], // Store the selected file
            }));
          };
    
          const handlePostBlog = async (e) => {
            e.preventDefault();
    
            const form = new FormData();
            for(let key in formData){
                form.append(key, formData[key]);
            }
    
            try{
                const response = await fetch('http://localhost:3002/api/post-blog', {
                    method: "POST",
                    body: form,
                });
                if(response.ok){
                    alert("Blog Posted Successfully");
                    setShowAddBlog(false);
                    window.location.reload();
                } else {
                    alert("Failed to post blog. Try again later.")
                }
            }
            catch(error){
                console.error("Error:", error);
            }
          };
          

    return (
        <>
            <section className='profile-area' onClick={() => setShowAddBlog(false)}>
                <div className='profile-area-inner' onClick={(e) => e.stopPropagation()}>
                    <i className="fa-solid fa-pen-nib profile-icon"></i><br />
                    <p className='fw-bold my-3'>Post New Blog</p>


                    <form className="row g-3 mt-4" onSubmit={handlePostBlog}>
                        <div className="col-12">
                            <input type="text" className="form-input" name='blog_title' value={formData.blog_title} onChange={handleChange} placeholder="Blog Title" required />
                        </div>
                        <div className="col-12">
                            <textarea type="text" className="form-input" name='blog_description' value={formData.blog_description} onChange={handleChange} style={{height: '8em'}} placeholder='Description' required></textarea>
                        </div>
                        <div className='col-12 text-start'>
                            <label for="Site Image" className='form-label text-muted' >Upload Blog Image</label>
                            <input type="file" class="form-input" name='blog_image' onChange={handleFileChange} required />
                        </div>

                        <div className="col-12 my-4">
                            <button type="submit" className="admin-btn py-3 rounded w-100">Submit Blog</button>
                        </div>
                    </form>
                    {/* form ends */}

                </div>
            </section>
        </>
    )
}

export default AdminBlogs
